// Campaigns page stage tabs (07 Interactive Prototype CAMPAIGNS). A root [data-ns-campaigns] holds tab buttons
// [data-ns-stage="<key>"] ("all" shows every card) and grid items [data-ns-stage-item] whose data-stage is their stage.
// Liquid renders the counts and leaves out a stage with no cards; this only toggles aria-pressed and hidden, and keeps the
// stage in the address (#pre-order) so a link from elsewhere, or Back, opens the same stage. No text is written.
export function stageFromHash(hash, keys) {
  let key = String(hash ?? '').replace(/^#/, '');
  try {
    key = decodeURIComponent(key).toLowerCase();
  } catch {
    return 'all';
  }
  return keys.includes(key) ? key : 'all';
}

export function stageView(stages, active) {
  const key = String(active ?? 'all');
  return stages.map(stage => key === 'all' || stage === key);
}

function init(root) {
  const tabs = [...root.querySelectorAll('[data-ns-stage]')];
  const items = [...root.querySelectorAll('[data-ns-stage-item]')];
  if (tabs.length === 0 || items.length === 0) return;
  const keys = tabs.map(tab => tab.getAttribute('data-ns-stage'));
  const show = key => {
    const view = stageView(items.map(item => item.getAttribute('data-stage')), key);
    for (const tab of tabs) tab.setAttribute('aria-pressed', String(tab.getAttribute('data-ns-stage') === key));
    items.forEach((item, index) => { item.hidden = !view[index]; });
  };
  root.addEventListener('click', event => {
    const tab = event.target.closest?.('[data-ns-stage]');
    if (!tab || !root.contains(tab)) return;
    const key = tab.getAttribute('data-ns-stage');
    show(key);
    const { pathname, search } = window.location;
    window.history.replaceState(window.history.state, '', key === 'all' ? pathname + search : `#${key}`);
  });
  window.addEventListener('hashchange', () => show(stageFromHash(window.location.hash, keys)));
  const first = stageFromHash(window.location.hash, keys);
  if (first !== 'all') show(first);
}

if (typeof document !== 'undefined') {
  for (const root of document.querySelectorAll('[data-ns-campaigns]')) init(root);
}
